import { cn } from "@/lib/utils";
import type { ElementType } from "react";

interface Props {
  text: string;
  className?: string;
  as?: ElementType;
  delay?: number;
  /** Highlight specific words by index (0-based) with this className */
  highlight?: { indices: number[]; className: string };
}

export function KineticHeading({ text, className, as: Tag = "h1", delay = 0, highlight }: Props) {
  const words = text.split(" ");

  return (
    <Tag className={cn("text-balance", className)}>
      <span className="inline">
        {words.map((w, i) => {
          const isHighlight = highlight?.indices.includes(i);
          return (
            <span key={i} className="inline-block overflow-hidden align-baseline pb-[0.08em]">
              <span
                className={cn(
                  "inline-block animate-kinetic-rise",
                  isHighlight && highlight?.className,
                )}
                style={{ animationDelay: `${delay + i * 0.06}s` }}
              >
                {w}
                {i < words.length - 1 && "\u00A0"}
              </span>
            </span>
          );
        })}
      </span>
    </Tag>
  );
}
